import { useEffect } from "react";
import {
  CommonLayout,
  ConfigLayoutDashboards,
  ListViewLayout,
} from "../../layouts";
import { useDashboardService } from "services";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  currentDashboardState,
  dashboardsState,
  newItemState,
  Dashboard,
} from "states";
import { Notify } from "components/core";
import { useListStatus } from "molecules/listState/useListStatus";
import { ENTITY_TYPE } from "../../../constants";
import styles from "./Home.module.css";

export const Home = () => {
  const [dashboards, setDashboards] = useRecoilState(dashboardsState);
  const [currentDashboard, setCurrentDashboard] = useRecoilState(currentDashboardState);
  const dashboardService = useDashboardService();
  const { status, track } = useListStatus();

  const isDashboardSelected = Object.keys(currentDashboard).length > 0;
  const setIsNewItem = useSetRecoilState(newItemState);

  useEffect(() => {
    setIsNewItem(false); // reset stale add-new state on every mount
    setCurrentDashboard({} as Dashboard); // reset to list view — prevents stale open dashboard showing on nav click
    getDashboards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashboards = () => {
    track(dashboardService.getDashboards()).then(
      (response: any) => {
        if (response.length > 0) setDashboards(response);
      },
      (error) => Notify.error(error)
    );
  };

  return (
    <CommonLayout>
      <div className={styles.pageArea}>
        {/*
          When no dashboard is selected → full-width card grid list
          When a dashboard is selected  → full-width detail panel
          The list is always mounted (keeps Recoil state alive) but
          visually hidden when the detail panel is open.
        */}
        <div className={isDashboardSelected ? styles.hidden : styles.fullWidth}>
          <ListViewLayout
            listItems={dashboards}
            showFloatingBtn={true}
            btnText="New dashboard"
            itemType={ENTITY_TYPE.DASHBOARD}
            status={status}
            onRetry={getDashboards}
          />
        </div>

        {isDashboardSelected && (
          <div className={styles.fullWidth}>
            <ConfigLayoutDashboards />
          </div>
        )}
      </div>
    </CommonLayout>
  );
};